import React from "react";
import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Container } from "react-bootstrap";

const Footer = () => {
  const { accounts } = useMsal();

  return (
    <footer className="mt-5 py-3 bg-light border-top">
      <Container>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <img src="/lehmannlogo.png" height="30px" alt="Lehmann Logo" className="me-2" />
          </div>
          <AuthenticatedTemplate>
            <div className="text-muted small">
              {accounts[0]?.name}
            </div>
          </AuthenticatedTemplate>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
